import React from 'react'

import "./phd.css"
// import prof2 from "./profiles/profimages/prof2.jpg";
import { FaEnvelope} from 'react-icons/fa';
import mukul from "./staffimages/mukul_kumar.png"
import samina from "./staffimages/sameena_rapphik.jpg"
import ankush from "./staffimages/ankush_marodkar.png"
import lok from "./staffimages/lok.jpg"
import girish from "./staffimages/girish.png"
import Mayank from "./staffimages/mayank.jpg"
// import vik from "./staffimages/vikesh.jpg"
import Suman from "./staffimages/suman.jpg"
import SOURAV from "./staffimages/sourav.png"
import som from "./staffimages/somnathji.png"
import Shrish from "./staffimages/shrish.jpg"
import Sheetal from "./staffimages/sheetal.jpg"
import sexena from "./staffimages/sexena.jpg"
import sahu from "./staffimages/sahu.png"
import rajore from "./staffimages/rajore.jpg"
import PIYUSH from "./staffimages/pyush.jpg"
import Patil from "./staffimages/patil.jpg"
import NILESH from "./staffimages/nilesh.png"
// import myk from "./staffimages/mykmishra.png"
// import MULANI from "./staffimages/mulani.jpg"
import Mukherjee from "./staffimages/mukherjee.png"
import MUKESH from "./staffimages/mukesh.jpg"
import mpillai from "./staffimages/mpillai.jpg"
// import mkt from "./staffimages/mkt.jpg"
// import myka from "./staffimages/mayank.jpg"
import MANISH from "./staffimages/manish.jpg"
import Man from "./staffimages/man.jpg"

import l from "./staffimages/L.jpg"
import KANWADE from "./staffimages/kanwade.png"
import Hari from "./staffimages/hari.png"
import Gopi from "./staffimages/gopi.jpg"
import Dubey from "./staffimages/dubey.png"
import dpk from "./staffimages/dpk.jpg"
// import david from "./staffimages/david.png"
import Bimli from "./staffimages/bimli.png"
import Bhowmik from "./staffimages/bhowmik.png"
import BEHERA from "./staffimages/behera.jpg"
import as from "./staffimages/as.jpg"
// import ALIS from "./staffimages/alis.jpg"
// import ask from "./staffimages/aks.png"
import Adarsh from "./staffimages/adarsh.jpg"
import adk from "./staffimages/akd.jpg"
import aks from "./staffimages/aks.png"
import vikesh from "./staffimages/vikesh.jpg"
import def from "./staffimages/default.jpg"









const Phd = () => {
  return (
   <>
  
   <div className="faculty-main">
        <div className="faculty-width">
          <div className="hodsec">
            <img
              src={mukul}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">MUKUL KUMAR</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1701205009@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2017  </div>
                <div className="post"> Research Area		: --  </div>
                <div className="post"> Faculty Advisor 		: Dr. Somaditya Sen ,Dr. Sudip Chakraborty </div>
               
              </div>
            </div>
          </div>
          <div className="hodsec">
            <img
                     src={samina}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">MULANI SAMEENA RAPPHIK</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1801205002@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2018  </div>
                <div className="post"> Research Area		: Photoactive material  </div>
                <div className="post"> Faculty Advisor 		: Dr. Rupesh S. Devan</div>
               
              </div>
            </div>
          </div>
          <div className="hodsec">
            <img
                    src={ankush}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">ANKUSH SUNIL MARODKAR</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1801205010@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2018  </div>
                <div className="post"> Research Area		: --  </div>
                <div className="post"> Faculty Advisor 		: Dr. Hemant Borkar </div>
               
              </div>
            </div>
          </div>
          <div className="hodsec">
            <img
               src={PIYUSH}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">PIYUSH KUMAR</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1801205011@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2018  </div>
                <div className="post"> Research Area		:High temperature behavior of high entropy Alloys  </div>
                <div className="post"> Faculty Advisor 		: Dr. Abhijit Ghosh ,Dr. Sumanta Samal </div>
               
              </div>
            </div>
          </div>
          <div className="hodsec">
            <img
                   src={girish}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Girish Khanna R</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1901105002@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		:Establishing Processing- Microstructure-Property paradigm in multicomponent high entropy alloy</div>
                <div className="post"> Faculty Advisor 		: Dr. Sumanta Samal </div>
               
              </div>
            </div>
          </div>
          <div className="hodsec">
            <img
                     src={Patil}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Patil Hitesh Devidas</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1901105004@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		: --  </div>
                <div className="post"> Faculty Advisor 		: Dr. Hemant Borkar ,Dr. Abhijit Ghosh</div>
               
              </div>
            </div>
          </div>
          <div className="hodsec">
            <img
                   src={Mayank}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Mayank Kumar Singh</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1901105005@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		:Advanced Functional Materials for Energy Storage Devices</div>
                <div className="post"> Faculty Advisor 		: Dr. Dhirendra Kumar Rai ,Dr. Srimanta Pakhira </div>
               
              </div>
            </div>
          </div>
          <div className="hodsec">
            <img
                    src={rajore}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Rajendra Prasad Bunkar</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1901105008@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		: --  </div>
                <div className="post"> Faculty Advisor 		: Dr. Rupesh S. Devan</div>
               
              </div>
            </div>
          </div>
          <div className="hodsec">
            <img
                  src={Shrish}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Shrish Nath Upadhyay</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1901105009@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		:Development of 2D TMDs for ORR and HER</div>
                <div className="post"> Faculty Advisor 		: Dr. Srimanta Pakhira,Dr. Mrigendra Dubey</div>
               
              </div>
            </div>
          </div>
        


          <div className="hodsec">
            <img
                  src={def}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Shrish Nath Upadhyay</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1901105009@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		:Development of 2D TMDs for ORR and HER</div>
                <div className="post"> Faculty Advisor 		: Dr. Srimanta Pakhira,Dr. Mrigendra Dubey</div>
               
              </div>
            </div>
          </div>



          <div className="hodsec">
            <img
                  src={Mukherjee}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Moupia Mukherjee</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1901105011@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		:Development of 2D TMDs for ORR and HER</div>
                <div className="post"> Faculty Advisor 		: Dr. Mrigendra Dubey,Dr. Srimanta Pakhira</div>
               
              </div>
            </div>
          </div>



          <div className="hodsec">
            <img
                  src={lok}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Lokanath Mohapatra</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd1901205001@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		:Development of 2D TMDs for ORR and HER</div>
                <div className="post"> Faculty Advisor 		: Dr. Ajay Kumar Kushwaha</div>
               
              </div>
            </div>
          </div>




          <div className="hodsec">
            <img
                  src={Sheetal}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Sheetal Gupta</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2001105003@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2020  </div>
                <div className="post"> Research Area		:Energy storage</div>
                <div className="post"> Faculty Advisor 		: Dr. Dhirendra Kumar Rai</div>
               
              </div>
            </div>
          </div>




          <div className="hodsec">
            <img
                  src={sahu}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">SUJIT SHIVAJI KADAM</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2001105004@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2020  </div>
                <div className="post"> Research Area		:Materials-Structure-Property Correlation Study in SGCI</div>
                <div className="post"> Faculty Advisor 		: Dr. Vinod Kumar</div>
               
              </div>
            </div>
          </div>




          <div className="hodsec">
            <img
                  src={Gopi}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Gopi Talluri</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2001105005@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2020  </div>
                <div className="post"> Research Area		:Design and Development of High-Performance Lightweight Cast Eutectic Multi-Principal Element Alloys</div>
                <div className="post"> Faculty Advisor 		:Dr. Ram Sajeevan Maurya</div>
               
              </div>
            </div>
          </div>





          <div className="hodsec">
            <img
                  src={as}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">ABHISHEK SRIVASTAVA</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2101105002@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2021  </div>
                <div className="post"> Research Area		:--</div>
                <div className="post"> Faculty Advisor 		: Dr. Parasharam M. Shirage,Dr. Kiran Bala</div>
               
              </div>
            </div>
          </div>





          <div className="hodsec">
            <img
                  src={KANWADE}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">ARCHANA RAJENDRA KANWADE</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2101105003@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2021  </div>
                <div className="post"> Research Area		:Engineering of Phosphate-based Cathode Materials for Sustainable Sodium-ion Batteries</div>
                <div className="post"> Faculty Advisor 		: Dr. Parasharam M. Shirage</div>
               
              </div>
            </div>
          </div>








          <div className="hodsec">
            <img
                  src={NILESH}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">NILESH KASHINATH KUMBHAR</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2101105004@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2021 </div>
                <div className="post">Research Area		:Tribology, Corrosion, and Biological Behaviour of Magnesium Alloys: The Role of Surface Engineering</div>
                <div className="post"> Faculty Advisor 		: Dr. Santosh S Hosmani</div>
               
              </div>
            </div>
          </div>












          <div className="hodsec">
            <img
                  src={MUKESH}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">MUKESH SINGH</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2101105005@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2021  </div>
                <div className="post"> Research Area		:Deformation behaviour of My alloys</div>
                <div className="post"> Faculty Advisor 		: Dr. Dudekula Althaf Basha</div>
               
              </div>
            </div>
          </div>














          <div className="hodsec">
            <img
                  src={def}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">SAKHARAM SANGALE</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2101105006@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2021  </div>
                <div className="post">Research Area		:--</div>
                <div className="post"> Faculty Advisor 		:Dr. Mrigendra Dubey</div>
               
              </div>
            </div>
          </div>














          <div className="hodsec">
            <img
                  src={Man}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">SAMTHAM MANOPRIYA</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2101105007@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2021  </div>
                <div className="post"> Research Area		:Energy Conversion and storage materials</div>
                <div className="post"> Faculty Advisor 		: Dr. Rupesh S. Devan</div>
               
              </div>
            </div>
          </div>














          <div className="hodsec">
            <img
                  src={som}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">SOMNATH NANDI</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2101105009@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2021  </div>
                <div className="post"> Research Area		:Creep in Nickel Base Superalloys</div>
                <div className="post"> Faculty Advisor 		: Dr. Abhijit Ghosh</div>
               
              </div>
            </div>
          </div>














          <div className="hodsec">
            <img
                  src={SOURAV}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">SOURAV KUMAR</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2201105009@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022 </div>
                <div className="post">Research Area		:Mechanical behavior analysis of Additively manufactured samples.</div>
                <div className="post"> Faculty Advisor 		: Dr. Eswara Prasad Korimilli</div>
               
              </div>
            </div>
          </div>











          <div className="hodsec">
            <img
                  src={adk}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">ASISH KUMAR DAS</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2201205001@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022  </div>
                <div className="post"> Research Area		:--</div>
                <div className="post"> Faculty Advisor 		: Dr. Vinod Kumar</div>
               
              </div>
            </div>
          </div>
















          <div className="hodsec">
            <img
                  src={mpillai}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">GOKUL M PILLAI</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2201205002@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022  </div>
                <div className="post">Research Area		:Multicomponent magnetic alloys</div>
                <div className="post"> Faculty Advisor 		: Dr. Vinod Kumar</div>
               
              </div>
            </div>
          </div>















          <div className="hodsec">
            <img
                  src={aks}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">AKSHAY KUMAR SONWANE</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2201205005@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022  </div>
                <div className="post">Research Area		:Amorphous Ternary Alloy Films for Electrocatalytic Hydrogen Evolution.      </div>
                <div className="post"> Faculty Advisor 		:Dr. Ajay Kumar Kushwaha</div>
               
              </div>
            </div>
          </div>




















          <div className="hodsec">
            <img
                  src={dpk}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">DEEPAK KUMAR SRIVASTAVA</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2201205006@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022  </div>
                <div className="post"> Research Area		:BULK METALLIC COMPOSITE GLASS</div>
                <div className="post"> Faculty Advisor 		: Dr. Ram Sajeevan Maurya</div>
               
              </div>
            </div>
          </div>











          <div className="hodsec">
            <img
                  src={def}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">PATIL ALIS ALATEKAR AJAY JANGONDA</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2201205007@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022  </div>
                <div className="post">Research Area		:Photoactive materials</div>
                <div className="post"> Faculty Advisor 		:Dr. Rupesh S. Devan</div>
               
              </div>
            </div>
          </div>
















          <div className="hodsec">
            <img
                  src={def}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Gami Pratiksha Kantilal</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2201205008@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022 </div>
                <div className="post"> Research Area		:--</div>
                <div className="post"> Faculty Advisor 		: Dr. Sunil Kumar</div>
               
              </div>
            </div>
          </div>












          <div className="hodsec">
            <img
                  src={BEHERA}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">SUDHIR BEHERA</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2201205011@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022  </div>
                <div className="post"> Research Area		:Additive Manufacturing</div>
                <div className="post"> Faculty Advisor 		:Dr. Jayaprakash</div>
               
              </div>
            </div>
          </div>













          <div className="hodsec">
            <img
                  src={Bimli}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Santosh Bimli</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:mtphd1906105001@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post"> Research Area		:--</div>
                <div className="post"> Faculty Advisor 		: Dr. Rupesh S. Devan,Dr. Parasharam M. Shirage</div>
               
              </div>
            </div>
          </div>













          <div className="hodsec">
            <img
                  src={vikesh}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Vikesh Kumar</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:mtphd1906105002@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2019  </div>
                <div className="post">Research Area		:Experimental and Computational Studies of Severely Surface Deformed Stainless Steel</div>
                <div className="post"> Faculty Advisor 		: Dr. Santosh S Hosmani,Dr. Indrasen Singh</div>
               
              </div>
            </div>
          </div>













          <div className="hodsec">
            <img
                  src={def}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">MANISH KUMAR TIWARI</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:mtphd2006105001@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2020  </div>
                <div className="post">Research Area		:Next-Generation Gas Sensors</div>
                <div className="post"> Faculty Advisor 		: Dr. Parasharam M. Shirage</div>
               
              </div>
            </div>
          </div>














          <div className="hodsec">
            <img
                  src={MANISH}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">MANISH BADOLE</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:mtphd2006105002@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2020  </div>
                <div className="post"> Research Area		:--</div>
                <div className="post"> Faculty Advisor 		: Dr. Sunil Kumar</div>
               
              </div>
            </div>
          </div>












          <div className="hodsec">
            <img
                  src={l}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Naveen L</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:mtphd2206105001@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022  </div>
                <div className="post">Research Area		:--</div>
                <div className="post"> Faculty Advisor 		: Dr. Sumanta Samal</div>
               
              </div>
            </div>
          </div>














          <div className="hodsec">
            <img
                  src={Hari}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Hari Narayanan Vasavan</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:mtphd2206105002@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2022  </div>
                <div className="post"> Research Area		:Na ion</div>
                <div className="post"> Faculty Advisor 		: Dr. Sunil Kumar</div>
               
              </div>
            </div>
          </div>
















          <div className="hodsec">
            <img
                  src={sexena}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Samriddhi Saxena</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:mtphd2301105008@iiti.ac.in </div>
                <div className="post"> Year Of Joining : 2023  </div>
                <div className="post">Research Area		:Development of layered oxide cathodes for sodium-ion batteries</div>
                <div className="post"> Faculty Advisor 		: Dr. Sunil Kumar</div>
               
              </div>
            </div>
          </div>















          <div className="hodsec">
            <img
                  src={Dubey}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Akshita Dubey</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2301105001@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2023  </div>
                <div className="post"> Research Area		:Corrosion </div>
                <div className="post"> Faculty Advisor 		: Dr. Nisheeth</div>
               
              </div>
            </div>
          </div>
















          <div className="hodsec">
            <img
                  src={sahu}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Bharat Kumar sahu</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2301105002@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2023  </div>
                <div className="post"> Research Area		:Multifunctional synthesis of soft material</div>
                <div className="post"> Faculty Advisor 		: Dr. Dubey</div>
               
              </div>
            </div>
          </div>



















          <div className="hodsec">
            <img
                  src={Mayank}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Mayank Mishra</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2301105003@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2023  </div>
                <div className="post">Research Area		:Deformation Behaviour Of Magnesium Alloys</div>
                <div className="post"> Faculty Advisor 		: Dr. Basha</div>
               
              </div>
            </div>
          </div>














          <div className="hodsec">
            <img
                  src={rajore}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Shraddha Manohar Rajore</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2301105004@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2023  </div>
                <div className="post">Research Area		:Next generation energy storage devices</div>
                <div className="post"> Faculty Advisor 		:Prof. Shirage</div>
               
              </div>
            </div>
          </div>















          <div className="hodsec">
            <img
                  src={Suman}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Suman Yadav</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2301105005@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2023  </div>
                <div className="post"> Research Area		:--</div>
                <div className="post"> Faculty Advisor 		:Prof. Rupesh</div>
               
              </div>
            </div>
          </div>
















          <div className="hodsec">
            <img
                  src={Bhowmik}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Suporna Bhowmik</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2301105006@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2023  </div>
                <div className="post">Research Area		:Research on Metal Organic Framework and its emerging applications in Energy storage and CO2 Fixation </div>
                <div className="post"> Faculty Advisor 		: Dr. Sumanta</div>
               
              </div>
            </div>
          </div>

















          <div className="hodsec">
            <img
                  src={Adarsh}
              className="hodimg"
              alt="okf"
            />

            <div className="hodtext">
              <div className="hodtext1">
                <div className="name">Adarsh Gaurav</div>
                <div className="post"> Email	 (<i><FaEnvelope/></i>)	:phd2301105007@iiti.ac.in</div>
                <div className="post"> Year Of Joining : 2023  </div>
                <div className="post">Research Area		:Additive manufacturing </div>
                <div className="post"> Faculty Advisor 		: Dr. Jayaprakash</div>
               
              </div>
            </div>
          </div>



        
        </div>
      </div>
   
   
  
   
   </>
  )
}

export default Phd
